import BaseService from "../../services/BaseService";
import ReportService from "../../services/ReportService";

export default {
    state: {
        income_statement: [],
    },
    getters: {
        incomeStatement: state => {
            return state.income_statement;
        },
    },
    mutations: {
        SET_INCOME_STATEMENT(state, income_statement) {
            state.income_statement = income_statement;
        },
    },
    actions: {
        async incomeStatement( { commit }, filter) {
            if (filter) {
                let result = await ReportService.incomeStatement(filter);
                if (result.status === BaseService.STATUS_200) {
                    commit('SET_INCOME_STATEMENT', result.data);
                }
            }
        },
    },
}